import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { IhmLinkModule } from '../ihm-link/ihm-link.module';
import { IhmNotificationsModule } from '../ihm-notifications/ihm-notifications.module';
import { AdPlusHeaderComponent } from './adplus-header.component';

@NgModule({
  imports: [CommonModule, RouterModule, MatCardModule, MatTooltipModule, MatDividerModule, IhmNotificationsModule, IhmLinkModule],
  declarations: [AdPlusHeaderComponent],
  exports: [AdPlusHeaderComponent]
})
export class AdPlusHeaderModule {}
